module.exports = __webpack_public_path__ + "media/images/icons/quote-2-3c65c1a110fb2b4f631120b7f2872acc.svg";